import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../api/client';

// Liste des notifications de l'utilisateur courant (polling pour rester à jour)
export const useNotifications = (filters = {}, pagination = { page: 1, limit: 20 }) => {
  return useQuery({
    queryKey: ['notifications', filters, pagination],
    queryFn: async () => {
      const params = new URLSearchParams();
      Object.entries({ ...filters, ...pagination }).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value);
        }
      });
      return apiClient.get(`/notifications?${params.toString()}`);
    },
    refetchInterval: 30000,
    staleTime: 15000
  });
};

export const useUnreadNotificationsCount = () => {
  return useQuery({
    queryKey: ['notifications', 'non-lues', 'count'],
    queryFn: () => apiClient.get('/notifications/non-lues/count'),
    refetchInterval: 30000,
    staleTime: 15000
  });
};

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => apiClient.post(`/notifications/${id}/lire`),
    onSuccess: () => {
      queryClient.invalidateQueries(['notifications']);
    }
  });
};

export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => apiClient.post('/notifications/lire-tout'),
    onSuccess: () => {
      queryClient.invalidateQueries(['notifications']);
    }
  });
};

export const useDeleteNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => apiClient.delete(`/notifications/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries(['notifications']);
    }
  });
};
